export const purchaseUrl =
  'https://combo-completo-rehabilitacion-lumbar.impultienda.ar/checkout'

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/djSuSGqARrdDMP2G3Fc2sK/ChatGPT_Image_3_sept_2026,_07_39_55_p.m..png'

export const heroStats = [
  ['+200', 'personas confiaron'],
  ['4', 'Módulos listos'],
  ['3', 'Bonos incluidos'],
  ['4,9/5', 'calificación ⭐'],
] as const

export const testimonials = [
  {
    initials: 'JM',
    name: 'Javier M.',
    place: 'Buenos Aires · Abogado',
    text: 'Por primera vez en 2 años puedo levantarme sin pensar en el dolor. Los ejercicios son simples pero funcionan.',
  },
  {
    initials: 'CP',
    name: 'Claudia P.',
    place: 'Rosario · Maestra',
    text: 'Tenía miedo de agacharme. Con el Módulo 3 recuperé confianza total. Ahora cargo bolsas sin pensar.',
  },
  {
    initials: 'RM',
    name: 'Ramiro M.',
    place: 'Mendoza · Vendedor',
    text: 'Hice fisio durante 6 meses sin mejorar. Este sistema me mostró qué estaba haciendo mal. En 30 días noté diferencia.',
  },
]

export const developedTestimonials = [
  {
    initials: 'JM',
    name: 'Javier M.',
    place: 'Buenos Aires · 38 años · Abogado',
    result: 'De la crisis al control total en 30 días',
    text: 'Tenía una hernia de disco. Mi médico me dijo que los ejercicios caseros no iban a servir. Hice los módulos 1 y 2, y en un mes el dolor bajó de 8/10 a 2/10. Hoy estoy en el módulo 3 fortaleciendo. No creía que fuera posible sin cirugía.',
  },
  {
    initials: 'CP',
    name: 'Claudia P.',
    place: 'Rosario · 45 años · Maestra',
    result: 'Recuperé la vida que tenía antes',
    text: 'Llevaba 3 años con dolor crónico lumbar. No podía estar de pie dando clases. Con el sistema entendí qué estaba haciendo mal: no activaba los glúteos. Cambiaron las cosas en 6 semanas. Ahora estoy en el módulo 4 manteniéndome, y no tengo miedo de volver a recaer.',
  },
  {
    initials: 'RM',
    name: 'Ramiro M.',
    place: 'Mendoza · 52 años · Vendedor',
    result: 'Los ejercicios funcionan porque son simples y realistas',
    text: 'Probé todo: kinesiólogos, inyecciones, remedios. Nada duraba. Este sistema me mostró que el problema no era la espalda, era cómo me movía. Los módulos son paso a paso sin complicaciones. Hace 4 meses que estoy sin crisis.',
  },
  {
    initials: 'SL',
    name: 'Silvina L.',
    place: 'La Plata · 41 años · Administrativa',
    result: '8 horas sentada y sin dolor al final del día',
    text: 'Trabajo 8 horas frente a la computadora y llegaba a casa destruida. El Bono 2 me hizo rearmar el escritorio y las pausas activas, y el Módulo 2 me destrabó la cadera. A las tres semanas dejé de terminar el día con la lumbar caliente.',
  },
  {
    initials: 'HG',
    name: 'Héctor G.',
    place: 'Córdoba · 61 años · Jubilado',
    result: 'Volví a jugar con mis nietos en el piso',
    text: 'A los 61 pensaba que el dolor era “la edad”. Empecé con el plan de 7 minutos del Módulo 1 porque no podía más, y seguí con la rutina de mantenimiento. Hoy me agacho, levanto a mi nieta y subo escaleras sin la puntada de siempre.',
  },
]

export const modules = [
  {
    icon: '🆘',
    name: 'Módulo 1 — Fase S.O.S Descompresión',
    period: 'Semana 1-4 · Alivio del dolor agudo',
    content: [
      '8 ejercicios de descompresión inmediata',
      'Posiciones seguras para el dolor',
      'Plan de 3 y 7 minutos para crisis',
      'Protocolo de sueño antiinflamatorio',
      'Errores que empeoran el dolor + cómo evitarlos',
    ],
  },
  {
    icon: '🔓',
    name: 'Módulo 2 — Desbloqueo de Cadera y Pelvis',
    period: 'Semana 5-8 · Movilidad y flexibilidad',
    content: [
      '10 ejercicios para cadera rígida',
      'Estiramientos progresivos',
      'Activación de glúteos (clave para la lumbar)',
      'Rutina diaria de 10 minutos',
      'Test de movilidad paso a paso',
    ],
  },
  {
    icon: '💪',
    name: 'Módulo 3 — El Núcleo de Acero',
    period: 'Semana 9-12 · Fortalecimiento real',
    content: [
      '12 ejercicios de core profundo',
      'Progresión de fácil a desafiante',
      'Cómo levantar peso sin peligro',
      'Técnica correcta para agacharse',
      'Plan de 6 semanas de fortalecimiento',
    ],
  },
  {
    icon: '🛡️',
    name: 'Módulo 4 — Mantenimiento y Cargas Diarias',
    period: 'Semana 13+ · Protección de por vida',
    content: [
      'Rutina de mantenimiento semanal',
      'Cómo cargar bolsas, niños, peso',
      'Ergonomía para la vida real',
      'Plan anti-recaídas',
      'Checklist de “espalda protegida”',
    ],
  },
]

export const bonuses = [
  [
    '01',
    '🎁',
    'Kit Anticrisis Lumbar',
    'Rescate en 10 minutos para esos días donde todo se traba. Qué hacer exacto, paso a paso, sin pánico.',
    '$12.000',
  ],
  [
    '02',
    '📚',
    'Oficina Sin Dolor Lumbar',
    'Cómo acomodar tu lugar de trabajo, pausas activas, estiramientos al lado del escritorio y rutina para antes/después de trabajar.',
    '$10.000',
  ],
  [
    '03',
    '🌅',
    'Mañanas Sin Rigidez Lumbar',
    'Rutina de 10 minutos desde que te despertás hasta que te levantás. Técnica correcta para evitar la rigidez matutina.',
    '$12.000',
  ],
] as const

export const pains = [
  'Dolores que van y vienen sin razón aparente.',
  'Miedo constante a una “mala postura” que te lance a crisis.',
  'Kinesiólogos caros, pastillas, inyecciones… y el problema sigue.',
  'Noches sin dormir por culpa del dolor.',
  'No poder cargar a tus hijos o bolsas del supermercado sin tensionar.',
  'Vivir “cuidándote” como si fueras de vidrio.',
]

export const faqs = [
  [
    '¿Sirve si tengo hernia de disco o ciática?',
    'Sí. Los módulos 1 y 2 están diseñados específicamente para eso. El sistema trabaja descompresión y desbloqueo antes de fortalecer. Si el dolor es muy fuerte (8+/10), consultá a un profesional primero.',
  ],
  [
    '¿Los ejercicios necesitan aparatos?',
    'No. Todo se hace en casa, con tu peso corporal o cosas que ya tenés (almohada, pared, silla). Sin equipos, sin gastos extra.',
  ],
  [
    '¿Cuánto tiempo lleva ver resultados?',
    'Semana 2-3 ya notás diferencia en movilidad y dolor. Semana 4-6 la mejora es evidente. Meses 2-3 la transformación es clara.',
  ],
  [
    '¿Necesito experiencia previa?',
    'No. Los módulos están hechos para personas SIN experiencia. Paso a paso, ultra claro, sin jerga médica.',
  ],
  [
    '¿Funciona si tengo 60+ años?',
    'Sí. Los ejercicios se adaptan a cualquier edad. El sistema respeta tu ritmo y tu capacidad.',
  ],
  [
    '¿Es reemplazo de un médico?',
    'No. Es una guía práctica de autocuidado. Si tenés síntomas graves (hormigueo, debilidad, pérdida de control), consultá a un profesional primero.',
  ],
  [
    '¿Cómo accedo después de pagar?',
    'Inmediatamente. Pagás y recibís un email con tu link de descarga en 5 minutos. Está en PDF, podés leerlo en cualquier dispositivo.',
  ],
  [
    '¿Hay soporte?',
    'Sí. Escribís a compradigitalyaa@gmail.com si tenés dudas sobre los ejercicios o necesitás una aclaración.',
  ],
  [
    '¿Tiene garantía real?',
    'Sí, 7 días. Escribís a compradigitalyaa@gmail.com y te devolvemos el 100%. Sin justificaciones. La tasa de devoluciones es menor al 0,3%.',
  ],
  [
    '¿Cómo puedo pagar?',
    'En pesos argentinos con Mercado Pago, tarjeta o transferencia, con cuotas según tu banco.',
  ],
] as const

export const recentPurchases = [
  ['Javier Ferreyra', 'Rosario, Santa Fe'],
  ['Marcela Ibáñez', 'Córdoba Capital, Córdoba'],
  ['Rocío Maidana', 'La Plata, Buenos Aires'],
  ['Gustavo Rojas', 'Mendoza, Mendoza'],
  ['Belén Sosa', 'Mar del Plata, Buenos Aires'],
  ['Martín Quiroga', 'San Miguel de Tucumán, Tucumán'],
  ['Lucía Benítez', 'Neuquén, Neuquén'],
  ['Daniel Ojeda', 'Salta, Salta'],
] as const
